import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "@/components/ui/accordion";
import { FAQS } from "@/data/faqs";

export default function FAQ() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative bg-[#F9F8F6] py-24 sm:py-32"
    >
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
          {/* Sticky left column */}
          <div className="lg:col-span-5 reveal">
            <div className="lg:sticky lg:top-28">
              <p className="text-[11px] tracking-[0.4em] uppercase text-[#5C6658] mb-6">
                09 / Frequently asked
              </p>
              <h2 className="font-[Outfit] font-extralight text-[#2D332B] text-[36px] sm:text-[52px] leading-[1.04] tracking-[-0.015em]">
                Everything you might
                <br />
                <span className="italic text-[#8A9A86]">
                  want to know.
                </span>
              </h2>
              <p className="mt-8 max-w-md text-[15px] leading-relaxed text-[#5C6658]">
                A few common questions about our design, maintenance, rental
                and bonsai offerings. Don&rsquo;t see yours? Write to&nbsp;
                <a
                  href="mailto:sujal@indoorgreens.in"
                  data-testid="faq-email"
                  className="link-underline text-[#2D332B]"
                >
                  sujal@indoorgreens.in
                </a>
                .
              </p>
            </div>
          </div>

          {/* Right column — accordion */}
          <div className="lg:col-span-7 reveal">
            <Accordion
              type="single"
              collapsible
              className="w-full"
              data-testid="faq-accordion"
            >
              {FAQS.map((item, i) => (
                <AccordionItem
                  key={i}
                  value={`item-${i}`}
                  data-testid={`faq-item-${i}`}
                  className="border-b border-[#E5E1DB]"
                >
                  <AccordionTrigger className="py-6 text-left [&[data-state=open]>svg]:rotate-180">
                    <span className="flex items-start gap-6 pr-4">
                      <span className="font-[Outfit] text-[12px] tracking-[0.25em] text-[#8A9A86] mt-2 shrink-0">
                        {String(i + 1).padStart(2, "0")}
                      </span>
                      <span className="font-[Outfit] text-[17px] sm:text-[19px] font-light text-[#2D332B] leading-snug">
                        {item.q}
                      </span>
                    </span>
                  </AccordionTrigger>
                  <AccordionContent className="pb-6 pl-12 pr-2 sm:pl-14">
                    <p className="text-[15px] leading-[1.75] text-[#5C6658]">
                      {item.a}
                    </p>
                    {item.list && (
                      <ul
                        data-testid={`faq-list-${i}`}
                        className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-2 text-[14px] leading-[1.7] text-[#2D332B]"
                      >
                        {item.list.map((li, j) => (
                          <li
                            key={j}
                            className="flex items-start gap-3 before:content-[''] before:mt-2 before:w-1.5 before:h-1.5 before:rounded-full before:bg-[#8A9A86] before:shrink-0"
                          >
                            <span>{li}</span>
                          </li>
                        ))}
                      </ul>
                    )}
                    {item.footer && (
                      <p className="mt-4 text-[15px] leading-[1.75] text-[#5C6658]">
                        {item.footer}
                      </p>
                    )}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
}
